import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';

export interface SettingsSelectOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

export interface SettingsSelectProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  options: SettingsSelectOption[];
  disabled?: boolean;
  placeholder?: string;
  fullWidth?: boolean;
}

const SettingsSelect: React.FC<SettingsSelectProps> = ({
  label,
  value,
  onChange,
  options,
  disabled,
  placeholder,
  fullWidth = true,
}) => {
  const id = `settings-select-${label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <FormControl size="small" fullWidth={fullWidth}>
      <InputLabel id={id}>{label}</InputLabel>
      <Select
        labelId={id}
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        displayEmpty={Boolean(placeholder)}
      >
        {placeholder && (
          <MenuItem value="">
            <Typography variant="body2" color="text.secondary"><em>{placeholder}</em></Typography>
          </MenuItem>
        )}
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.icon ? (
              <Stack direction="row" spacing={1} alignItems="center">
                {opt.icon}
                <span>{opt.label}</span>
              </Stack>
            ) : (
              opt.label
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SettingsSelect;
